import { useState, useEffect } from 'react';
import { useApp } from '../context/AppContext';

const useContentPreloader = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const { actions } = useApp();

  const wpUrl = process.env.REACT_APP_WORDPRESS_URL || 'http://localhost:8080';

  const fetchSlideContent = async () => {
    try {
      const slidePromises = [];

      for (let i = 1; i <= 6; i++) {
        slidePromises.push(
          fetch(`${wpUrl}/wp-json/wp/v2/slides?slug=slide-${i}`)
            .then((response) => {
              if (!response.ok) {
                throw new Error(`Failed to fetch slide ${i}`);
              }
              return response.json();
            })
            .then((data) => ({
              slideId: i,
              content: data[0] || null
            }))
        );
      }

      const slideResults = await Promise.all(slidePromises);

      const slideContent = {};
      slideResults.forEach((result) => {
        if (result.content) {
          slideContent[`slide${result.slideId}`] = {
            ...result.content,
            acf: result.content.acf || {}
          };
        }
      });

      actions.setSlideContent(slideContent);

      return slideContent;
    } catch (err) {
      throw err;
    }
  };

  const preloadAssets = async () => {
    const staticAssets = [];

    const assetPromises = staticAssets.map((asset) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = resolve;
        img.onerror = reject;
        img.src = asset;
      });
    });

    return Promise.all(assetPromises);
  };

  useEffect(() => {
    const loadAllContent = async () => {
      try {
        setLoading(true);
        setError(null);

        await Promise.all([fetchSlideContent(), preloadAssets()]);

        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    loadAllContent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    loading,
    error
  };
};

export default useContentPreloader;
